export default "__VITE_ASSET__91506f6a__"